const useLegalMutations = () => {
  const process = {
    namespaced: true,
    state: {
      idDelete: 0,
    },
    getters: {
      idDelete: (state) => state.idDelete,
    },
    actions: {
      setDelete({ commit }, id) {
        commit('DELETE', id);
      },
    },
    mutations: {
      ['DELETE'](state, payload) {
        state.idDelete = payload.id;
      },
    },
  };
  return { process };
};

export default useLegalMutations;
